import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductFilterService {

  currentYear: any = new Date().getFullYear();

  constructor() { }

  makeNewFilter() {
    let newFilter = {
      Level: 1,
      gLvl: 1,
      gIDs: 0,

      Category: '',
      SubCategory: '',
      Title: '',

      Product: false,
      Carousel: false,
      Feature: false,
      Sale: false,

      ProductStart: false,
      ProductEnd: false,
    };
    return newFilter;
  }

  getNewFilter() {
    return this.makeNewFilter();
  }

  makeNewAdminOrderFilter() {
    let newFilter: any = {
      Processing: true,
      InTransit: true,
      ReadyForPickUp: true,
      Complete: true,
      Cancelled: true,
      Shipped: true,
      SelectedStatuses: null,
      Note: false,

      toggleView: true,
      editClicked: false,

      //groupSelector
      gLvl: 0,
      gIDs: [0],
      gType: 0,
      empGroup: [[0], [0], [0], [0], [0]],
      //new empGroup prop with default -2 since a team can have 0 as id
      empGroupCXOne: [[-2], [-2], [-2], [-2], [-2]],
      groupSelectorChanged: false,
      groupSelectorEmtpy: false,
      resetFilter: false,

      searchOrder: '',
      //sortBy: 1, ****check this one
      datePosition: 0,
      sortByPosition: 2,
      date: [
        { position: 0, value: 30, show: true, name: 'Last 30 days', keyLocalization: 'Last_30_Days' },
        { position: 1, value: 60, show: true, name: 'Last 60 days', keyLocalization: 'Last_60_Days' },
        { position: 2, value: 180, show: true, name: 'Last 6 months', keyLocalization: 'Last_6_Months' },
        { position: 3, value: this.currentYear, show: true, name: this.currentYear },
      ],

      dateCXOne: [
        { position: 0, value: 30, show: true, name: 'Last 30 days', keyLocalization: 'Last_30_Days' },
        { position: 1, value: 90, show: true, name: 'Last 90 days', keyLocalization: 'Last_90_Days' },
        { position: 2, value: 180, show: true, name: 'Last 6 months', keyLocalization: 'Last_6_Months' },
        { position: 3, value: this.currentYear, show: true, name: this.currentYear },
      ],

      sortBy: [
        { position: 0, value: 'PointStoreOrderID', reverse: false, name: 'OrderID: Low to High', },
        { position: 1, value: 'PointStoreOrderID', reverse: true, name: 'OrderID: High to Low' },

        { position: 2, value: 'DateOrdered', reverse: true, name: 'Date: Newest to Oldest' },
        { position: 3, value: 'DateOrdered', reverse: false, name: 'Date: Oldest to Newest' },

        { position: 4, value: 'OrderTotal', reverse: false, name: 'Total: Low to High' },
        { position: 5, value: 'OrderTotal', reverse: true, name: 'Total: High to Low' },

        { position: 6, value: 'LoginName', reverse: false, name: 'User: A to Z' },
        { position: 7, value: 'LoginName', reverse: true, name: 'User: Z to A' },

        { position: 8, value: 'OrderStatus', reverse: false, name: 'Status: A to Z' },
        { position: 9, value: 'OrderStatus', reverse: true, name: 'Status: Z to A' },
      ],
    };

    var i = 0;
    for (i = 1; i <= (this.currentYear - 2017); i++) {
      newFilter.date.push({ position: i + 3, value: this.currentYear - i, show: true, name: this.currentYear - i });
      //order management filter
      newFilter.dateCXOne.push({ position: i + 3, value: this.currentYear - i, show: true, name: this.currentYear - i });
    }
    return newFilter;
  }

  makeNewAgentOrderFilter() {
    let newFilter = {
      searchOrder: '',
    };
    return newFilter;
  }

  getNewAdminOrderFilter() {
    return this.makeNewAdminOrderFilter();
  }

  getNewAgentOrderFilter() {
    return this.makeNewAgentOrderFilter();
  }
}
